export const AcMapPublication = (publication) => {
  return {
    ...publication,
    title: publication.titel,
    summary: publication.samenvatting,
    published: publication['@self']?.published,
    category: publication.category || publication.categorie || publication.tooiCategorieNaam,
    published: publication.publicatiedatum || publication.published,
  };
}